import React, { useContext } from "react";
import { Grid, useMediaQuery } from "@material-ui/core";
import moment from "moment";
import qs from "qs";
import { useLocation } from "react-router";
import { translate as t } from "../../../../../infrastructure/translate/localization";
import DateFilter from "../../../../components/DateFilter";
import MultipleSelect from "../../../../components/MultipleSelect";
import useStyles from "./styles";
import { recurrentPaymentConfig } from "../../config";
import BenefitPlansContext from "../../../../../infrastructure/Contexts/components/data/BenefitPlanWrapper/context";
import CompanyContext from "../../../../../infrastructure/Contexts/components/data/CompanyWrapper/context";

export default function RecurrentPaymentsFilters({
  type,
  handleChangeFilter,
}: {
  type: string;
  handleChangeFilter(e: any): void;
}): JSX.Element {
  const isLaptop = useMediaQuery("(max-width:1440px)");
  const isBigScreen = useMediaQuery("(min-width: 2560px)");

  const { containerFilters, filterItem, extraItem } = useStyles({
    isLaptop,
    isBigScreen,
  });
  const { states, modalityFilter } =
    type in recurrentPaymentConfig
      ? recurrentPaymentConfig[type]
      : recurrentPaymentConfig.default;

  const { search } = useLocation();
  const params = qs.parse(search, { ignoreQueryPrefix: true });
  const { modelId, state, modalityId } = params;

  const { benefitPlans } = useContext(BenefitPlansContext);
  const { company } = useContext(CompanyContext);
  const { modalities } = company;

  const modalitiesList = modalities.map(({ modalityId: id, modalityName }) => ({
    value: id,
    name: modalityName,
  }));

  return (
    <Grid
      container
      item
      xs={10}
      className={containerFilters}
      alignItems="center"
    >
      <Grid item className={filterItem}>
        <DateFilter
          onChange={(date) => {
            if (date) {
              const { start, end } = date;
              handleChangeFilter({
                minRequestedAt: moment(start).format("YYYY-MM-DD"),
                maxRequestedAt: moment(end).format("YYYY-MM-DD"),
              });
            }
          }}
        />
      </Grid>
      <Grid item className={filterItem}>
        <MultipleSelect
          placeholder={t("common-messages.benefit-model")}
          multiple={false}
          onChange={(event) =>
            handleChangeFilter({ modelId: event.target.value, pageNumber: 1 })
          }
          initValues={modelId || ""}
          list={benefitPlans.map(({ id, name }) => ({
            value: id,
            name,
          }))}
        />
      </Grid>
      <Grid item className={filterItem}>
        <MultipleSelect
          placeholder={t("employee-detail.state")}
          multiple={false}
          onChange={(event) =>
            handleChangeFilter({ state: event.target.value, pageNumber: 1 })
          }
          initValues={state || ""}
          list={states}
        />
      </Grid>
      {modalityFilter && (
        <Grid item className={extraItem}>
          <MultipleSelect
            placeholder={t("recurrent-payments-section.insurance-modality")}
            multiple={false}
            onChange={(event) =>
              handleChangeFilter({
                modalityId: event.target.value,
                pageNumber: 1,
              })
            }
            initValues={modalityId || ""}
            list={modalitiesList}
          />
        </Grid>
      )}
    </Grid>
  );
}
